export const BUSINESS_NAME = 'Preferred Service Heating & Air';
export const BUSINESS_LOCATION = 'South Jordan, UT 84095';
export const FOUNDED_YEAR = 2003;
export const OWNER_NAME = 'Steve Peterson';
export const HVAC_LICENSE = '5378066-5501';

export const PHONE_NUMBER = process.env.REACT_APP_PHONE_NUMBER || '(801) 577-2442';
export const PHONE_NUMBER_LINK = process.env.REACT_APP_PHONE_NUMBER_LINK || 'tel:+18015772442';
export const SMS_NUMBER = `+1${PHONE_NUMBER.replace(/\D/g, '').replace(/^1/, '')}`;
export const SMS_LINK = `sms:${SMS_NUMBER}`;
export const EMAIL_ADDRESS =
  process.env.REACT_APP_EMAIL_ADDRESS || 'preferredservice03@yahoo.com';
export const EMAIL_LINK = `mailto:${EMAIL_ADDRESS}`;

export const REGULAR_HOURS = 'Monday - Friday: 8:00 AM - 5:00 PM';
export const EMERGENCY_HOURS = 'Emergency service available 24 hours';
export const SERVICE_AREA_SUMMARY =
  'South Jordan and nearby Salt Lake County communities';

export const PRIMARY_CTA_TEXT = 'Request Service';
export const SECONDARY_CTA_TEXT = 'Call Now';
export const SUPPORT_CTA_TEXT = 'Read Customer Reviews';

export const CTA_MICROCOPY = [
  '24-Hour Emergency Service Available',
  'Serving South Jordan and surrounding areas since 2003',
  'Honest, dependable local service',
];
